import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import standardTable from '@/components/standardTable/index';
import { getTableData, deleteTable, batchDeleteTable, editTable } from '@/api/table';
import { formatJson } from '@/utils';
export default {
  name: 'tables',
  components: {
    standardTable
  },
  data() {
    return {
      typeOption: [{
        key: '待付款',
        label: '待付款'
      }, {
        key: '待发货',
        label: '待发货'
      }, {
        key: '已发货',
        label: '已发货'
      }, {
        key: '已收货',
        label: '已收货'
      }, {
        key: '已评价',
        label: '已评价'
      }],
      tableHead: [{
        slots: {
          title: '序号'
        },
        dataIndex: 'index',
        scopedSlots: {
          customRender: 'index'
        },
        width: 60
      }, {
        slots: {
          title: '用户id'
        },
        dataIndex: 'id',
        ellipsis: true
      }, {
        slots: {
          title: '付款人'
        },
        dataIndex: 'name'
      }, {
        slots: {
          title: '订单状态'
        },
        dataIndex: 'status'
      }, {
        slots: {
          title: '下单时间'
        },
        dataIndex: 'date',
        ellipsis: true
      }, {
        slots: {
          title: '付款金额'
        },
        dataIndex: 'money',
        scopedSlots: {
          customRender: 'money'
        }
      }, {
        slots: {
          title: '备注'
        },
        dataIndex: 'text',
        ellipsis: true
      }, {
        slots: {
          title: '操作'
        },
        scopedSlots: {
          customRender: 'action'
        },
        width: 140
      }],
      tableData: [],
      loading: false,
      selectedRowKeys: [],
      selectValue: [],
      currentEdit: {},
      editShow: false,
      filterList: {
        name: '',
        status: '',
        page: 1,
        size: 15,
        total: 0
      },
      deleteLoading: false,
      exportLoading: false
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    handleSelect(key, value) {
      this.selectedRowKeys = key;
      this.selectValue = value;
    },
    getTableData() {
      this.loading = true;
      const {
        name,
        status,
        page,
        size
      } = this.filterList;
      getTableData({
        page,
        size,
        name,
        status
      }).then(res => {
        const data = res.data || {};
        this.filterList.total = data.total || 0;
        this.tableData = data.list || [];
        this.loading = false;
      });
    },
    changeStatus(val) {
      this.filterList.status = val;
    },
    handleChangeCurrent(val) {
      this.filterList.page = val;
      this.getTableData();
    },
    search() {
      this.filterList.page = 1;
      this.getTableData();
    },
    handleEdit(val) {
      this.currentEdit = {
        ...val
      };
      this.editShow = true;
    },
    handleDelete(val) {
      const {
        id
      } = val;
      deleteTable({
        id
      }).then(res => {
        this.getTableData();
        this.$message.success(this.$t('删除成功'));
      });
    },
    batchDeleteTable() {
      //模拟删除
      if (this.selectValue.length == 0) {
        this.$message.warning(this.$t('请至少勾选一项'));
        return;
      }
      this.deleteLoading = true;
      const batchId = this.selectValue.map(item => item.id).join(',');
      batchDeleteTable({
        batchId
      }).then(res => {
        this.getTableData();
        this.$message.success(this.$t('批量删除成功'));
        this.deleteLoading = false;
      });
    },
    handleOk() {
      const {
        id,
        text
      } = this.currentEdit;
      editTable({
        id,
        text
      }).then(res => {
        this.$message.success(this.$t('修改成功') + '！');
        this.editShow = false;
        this.getTableData();
      });
    },
    //导出
    handleExport() {
      //由于是前端导出，所以只能导出当前的页的15条数据
      this.exportLoading = true;
      import('@/vendor/Export2Excel').then(excel => {
        const header = [],
          filterVal = [];
        this.tableHead.forEach(item => {
          if (item.title != this.$t('操作') && item.title != this.$t('序号')) {
            header.push(item.title);
            filterVal.push(item.dataIndex);
          }
        });
        const data = formatJson(this.tableData, filterVal);
        excel.export_json_to_excel({
          header,
          data,
          filename: this.$t('表单统计')
        });
        this.exportLoading = false;
      });
    }
  }
};